export const DOWNLOADS_PREFIX = '/';

export const CHALLENGES_REQUESTED = `${DOWNLOADS_PREFIX}CHALLENGES_REQUESTED`;

export const CHALLENGES_SUCCEEDED = `${DOWNLOADS_PREFIX}CHALLENGES_SUCCEEDED`;

export const CHALLENGES_FAILED = `${DOWNLOADS_PREFIX}CHALLENGES_FAILED`;

export const SET_SELECTED_COUNTRIES = `${DOWNLOADS_PREFIX}SET_SELECTED_COUNTRIES`;

export const COUNTRIES_AND_CITIES_REQUESTED = `${DOWNLOADS_PREFIX}COUNTRIES_AND_CITIES_REQUESTED`;

export const COUNTRIES_AND_CITIES_SUCCEEDED = `${DOWNLOADS_PREFIX}COUNTRIES_AND_CITIES_SUCCEEDED`;

export const COUNTRIES_AND_CITIES_FAILED = `${DOWNLOADS_PREFIX}COUNTRIES_AND_CITIES_FAILED`;

export const TAGS_REQUESTED = `${DOWNLOADS_PREFIX}TAGS_REQUESTED`;

export const TAGS_SUCCEEDED = `${DOWNLOADS_PREFIX}TAGS_SUCCEEDED`;

export const TAGS_FAILED = `${DOWNLOADS_PREFIX}TAGS_FAILED`;

export const USERS_REQUESTED = `${DOWNLOADS_PREFIX}USERS_REQUESTED`;

export const USERS_SUCCEEDED = `${DOWNLOADS_PREFIX}USERS_SUCCEEDED`;

export const USERS_FAILED = `${DOWNLOADS_PREFIX}USERS_FAILED`;

export const REPORT_PREVIEW_REQUESTED = `${DOWNLOADS_PREFIX}REPORT_PREVIEW_REQUESTED`;

export const REPORT_PREVIEW_SUCCEEDED = `${DOWNLOADS_PREFIX}REPORT_PREVIEW_SUCCEEDED`;

export const REPORT_PREVIEW_FAILED = `${DOWNLOADS_PREFIX}REPORT_PREVIEW_FAILED`;

export const REPORT_CSV_REQUESTED = `${DOWNLOADS_PREFIX}REPORT_CSV_REQUESTED`;

export const REPORT_CSV_SUCCEEDED = `${DOWNLOADS_PREFIX}REPORT_CSV_SUCCEEDED`;

export const REPORT_CSV_FAILED = `${DOWNLOADS_PREFIX}REPORT_CSV_FAILED`;

export const CLEAR_REPORT = `${DOWNLOADS_PREFIX}CLEAR_REPORT`;

export const REPORT_MAP_DATA_REQUESTED = `${DOWNLOADS_PREFIX}REPORT_MAP_DATA_REQUESTED`;
export const REPORT_MAP_DATA_SUCCEEDED = `${DOWNLOADS_PREFIX}REPORT_MAP_DATA_SUCCEEDED`;
export const REPORT_MAP_DATA_FAILED = `${DOWNLOADS_PREFIX}REPORT_MAP_DATA_FAILED`;

export const TAG_TYPE = [
    {
        key: 'litterati',
        label: 'Litterati',
        id: 'litterati',
    },
    {
        key: 'user',
        label: 'User Generated',
        id: 'userGenerated',
    },
];

export function endOfMonth(date) {
    return new Date(date.getFullYear(), date.getMonth(), 0, 23, 59, 59, 30);
}
export function startOfMonth(date) {
    return new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate() - 30,
        23,
        59,
        59,
        1,
    );
}
